var device;
//var pc_width = 1080;
var sp_width = 767;
var screen_sizes = [];
var header_fixed_cue = 1;
var getScreenSize = function() {
	var bw = window.innerWidth ? window.innerWidth : $(window).width();
	var bh = window.innerHeight ? window.innerHeight : $(window).height();
  	screen_sizes.push(bw);
  	screen_sizes.push(bh);
	if(screen_sizes[0] < sp_width){
		device ="sp";
	}else{
		device ="pc";
	}
	return screen_sizes;
}
$(function(){

	/* 全ページ共通 */
	var strActive = "active";
	var speed = 200;
	var ease = "easeInOutCubic";
	var PAGE = $("#Page");
	//var HEADER = $("#Header");
	var MENU = $("#Tools .menu");
	var SEARCH_BTN = $("#Tools .search a");
	//var SEARCH_BODY = $("#Tools .search .body");
	var NAV = $("#Nav");
	var TOOLS = $("#Tools");
	var LANG_BTN = $("#Tools .language a");
	var LANG_BODY = $("#Tools .language .body");
	var MYPAGE_BTN = $("#Tools .mypage a");
	var MYPAGE_BODY = $("#Tools .mypage .body");
	var CART_BTN = $("#Tools .bag a");
	var CART_BODY = $("#Tools .bag .body");
	var accordion = $(".accordion");
	var INFO = $("#Information");

	getScreenSize();


	//Menu
	var state = false;
	MENU.on('click', function(e) {
		var ty = $(window).scrollTop();
		if(ty < header_fixed_cue){
			$(window).scrollTop(header_fixed_cue,speed);
		}
		$(NAV).toggleClass(strActive);
		$(this).toggleClass(strActive);
		//Smartphone
		if(device=="sp"){
			$(TOOLS).toggleClass(strActive);
			if($(CART_BODY).css('display') == 'block') $(CART_BODY).stop().slideToggle(0);
		}
		if($(SEARCH_BTN).hasClass('active')) $(SEARCH_BTN).removeClass('active');
		$(LANG_BODY).hide();
		$(MYPAGE_BODY).hide();
		$(CART_BODY).hide();
		return false;
	});
	$('#Nav span').on('click', function(e) {
		closeNav();
	});

	//Search
	SEARCH_BTN.on('click', function(e) {
		$(LANG_BODY).hide();
		$(MYPAGE_BODY).hide();
		$(CART_BODY).hide();
		var target = e.currentTarget;
		$(target).toggleClass("active");
		$(target).parent().toggleClass(strActive);
		if(device=="pc"){
			closeNav();
		}else if($(".search.active").lenth){
			 $('#site-search').submit();
		}
	});

	//Laungage
	$(LANG_BODY).hide();
	LANG_BTN.on('click', function(e) {
		if($(SEARCH_BTN).hasClass('active')) $(SEARCH_BTN).removeClass('active');
		$(MYPAGE_BODY).hide();
		$(CART_BODY).hide();
		if(device=="sp") speed = 0;
		$(LANG_BODY).stop().slideToggle(0);
		if(device=="pc"){
			closeNav();
		}
	});
	//Mypage
	$(MYPAGE_BODY).hide();
	MYPAGE_BTN.on('click', function(e) {
		if($(SEARCH_BTN).hasClass('active')) $(SEARCH_BTN).removeClass('active');
		$(LANG_BODY).hide();
		$(CART_BODY).hide();
		if(device=="sp") speed = 0;
		$(MYPAGE_BODY).stop().slideToggle(0);
		if(device=="pc"){
			closeNav();
		}
	});
	//Cart
	$(CART_BODY).hide();
	CART_BTN.on('click', function(e) {
		if($(SEARCH_BTN).hasClass('active')) $(SEARCH_BTN).removeClass('active');
		$(LANG_BODY).hide();
		$(MYPAGE_BODY).hide();
		if(device=="sp") speed = 0;
		$(CART_BODY).stop().slideToggle(0);
		if(device=="pc"){
			closeNav();
		}
	});
	$('html').on('click', function(e) {
		if(device != "sp"){
			if($(":focus").attr("class") != 'langbtn' && $(":focus").attr("class") != 'mypagebtn' && $(":focus").attr("class") != 'bagbtn'){
				if($(":focus").attr("href") == undefined){
					if($(SEARCH_BTN).hasClass('active')) $(SEARCH_BTN).removeClass('active');
					$(LANG_BODY).hide();
					$(MYPAGE_BODY).hide();
					$(CART_BODY).hide();
				}
			}
		}
	});

	//accordion クラス付与(1階層のliへ)
	//1階層の h2 の直下に .child_link があった場合
	const acoLv1_Check = $('#Nav .accordion .block > h2 +.child_link');	
	if(acoLv1_Check.length !== 0){
		//直前の要素(h2)にaddClass
		$(acoLv1_Check).prev().addClass('head');
	}

	//accordion クラス付与(2階層のliへ)
	//2階層の ul.child_link > li に隣接した .grandchild_link があった場合
	const acoLv2_Check = $('#Nav .accordion .block > .child_link > li+.grandchild_link');
	 if(acoLv2_Check.length !== 0){
		//直前の要素(li)にaddClass
		$(acoLv2_Check).prev().addClass('head');
	}
	

	

	//accordion
	if(accordion.length){
		accordion.find(".body").hide();
		accordion.find(".head").on('click', function(e) {
			var target = e.currentTarget;
			$(target).toggleClass(strActive);
			$(target).next(".body").slideToggle(speed);
		});
	}

	//footer accordion
	if(device=="sp"){
		var Info_head = INFO.find("h3");
		INFO.find(".body").hide();
		Info_head.on('click', function(e) {
			$(this).toggleClass(strActive);
			$(this).next(".body").slideToggle(speed);
		});
	}

	//スムーススクロール
	$('a[href^="#"]').on('click',function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html,body").animate({scrollTop:position}, speed, ease);
		return false;
	});


	//inview
	var inview = $('.inview');
	inview.on('inview', function(event, isInView) {
        if (isInView) {
            $(this).addClass("move");// 表示されたら実行するアクション（関数）名
        }
    });
	/*===================================================
							Functions
	=====================================================*/
	closeNav = function(){
		$(MENU).removeClass(strActive);
		$(NAV).removeClass(strActive);
		$(TOOLS).removeClass(strActive);
	}

	/*===================================================
							Window
	=====================================================*/
	//ページが読み込まれたら実行1
	$(window).on('load',function() {
		$(PAGE).addClass(strActive);
		$("body").addClass(strActive);
		//カートアイコンの設定
		var count = 0;
	  function checkItem(){
			count++;
			if($('#ItemList').length){
				$('#Tools li.bag').addClass('active');
				$('#Tools li.bag a.bagbtn').append('<span>'+$('#ItemList .item').length+'</span>');
				clearInterval(intervalId);
			}
	  }
		var intervalId = setInterval(function(){
			checkItem();
			if(count >= 5) clearInterval(intervalId);
		}, 1000);

	});
	//ウィンドウリサイズしたら実行
	$(window).on('resize',function() {
		getScreenSize();
	});

	//スクロールしたら実行
	$(window).on('scroll',function() {
		var ty = $(window).scrollTop();
		if(ty >= header_fixed_cue){
			$(PAGE).addClass("fixed");
			//console.log(ty + "if");
		}else{
			$(PAGE).removeClass("fixed");
			//console.log(ty + "else");
			//closeNav();
		}
	});

	
});
